// PatientData Model
import { Model } from '@vuex-orm/core'

export default class PatientEmrIpfsOperativeNoteImage extends Model {
	// This is the name used as module name of the Vuex Store.
	static entity = 'PatientEmrIpfsOperativeNoteImages'

	// List of all fields (schema) of the post model. `this.attr` is used
	// for the generic field type. The argument is the default value.
	static fields() {
		return {
			id: this.attr(null),
			ipfs_file_user: this.attr(null),
			an: this.attr(null),
			hn: this.attr(null),
			key1: this.attr(null),
			key2: this.attr(null),
			key3: this.attr(null),
			datas: this.attr(null),
			list_orderby: this.number(0)
		}
	}
}
